export const convertGeoJSONToLatLng = (geojson: any) => {
  return geojson?.coordinates[0]?.map((coord: [number, number]) => ({
    lat: coord[1],
    lng: coord[0]
  }));
};
